const DATE_TIME = new Intl.DateTimeFormat("it-CH", {
  dateStyle: "short",
  timeStyle: "short",
  timeZone: "Europe/Zurich",
});

const DATE_ONLY = new Intl.DateTimeFormat("it-CH", {
  dateStyle: "short",
  timeZone: "Europe/Zurich",
});

// Verbose Italian format used on the detail page (e.g. "15 aprile 2026, 13:06").
const DATE_TIME_LONG = new Intl.DateTimeFormat("it-IT", {
  day: "numeric",
  month: "long",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Zurich",
});

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return DATE_TIME.format(d);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return DATE_ONLY.format(d);
}

export function formatDateTimeLong(iso: string | null | undefined): string {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return DATE_TIME_LONG.format(d);
}

export function formatConfidence(value: number | null): string {
  if (value === null || value === undefined) return "-";
  // OpenAI returns confidence on a 0-100 scale (see openaiService prompt),
  // so we just round and append the unit without rescaling.
  return `${Math.round(value)}%`;
}
